export const categories = [
  {
    slug: 'wanghong-heiliao',
    name: '网红黑料',
    description: '抖音快手B站网红塌房现场，网红私生活曝光、黑历史扒皮、翻车实录',
    icon: 'ri-user-unfollow-line',
  },
  {
    slug: 'mingxing-bagua',
    name: '明星八卦',
    description: '娱乐圈明星恋情、出轨、离婚、整容、耍大牌等最新八卦资讯',
    icon: 'ri-star-line',
  },
  {
    slug: 'shehui-redian',
    name: '社会热点',
    description: '社会热点事件深度追踪，热点争议话题讨论，第一手爆料信息',
    icon: 'ri-fire-line',
  },
  {
    slug: 'zhibo-fanche',
    name: '直播翻车',
    description: '直播带货翻车现场、主播失言、假货曝光、直播间争议事件',
    icon: 'ri-live-line',
  },
  {
    slug: 'yule-shendu',
    name: '娱乐深扒',
    description: '娱乐圈深度扒皮、资本运作内幕、圈内潜规则深度解读',
    icon: 'ri-search-eye-line',
  },
  {
    slug: 'chigua-qianxian',
    name: '吃瓜前线',
    description: '最新最快的吃瓜资讯，全网热搜话题追踪，粉丝互撕现场还原',
    icon: 'ri-chat-smile-2-line',
  },
];

export const categoryList = categories;